import { Card, Pagination, Space, Table } from "antd";
import moment from "moment";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function DatatableMonthlyPlanner(props: any) {
  const navigate = useNavigate();

  const sortedData = props.dataSource?.slice().sort((a: any, b: any) => {
    if (a.date && b.date) {
      return (
        moment(a.date).toDate().getTime() - moment(b.date).toDate().getTime()
      );
    }
    return a.date ? -1 : 1; // Ensure valid dates come before invalid ones
  });
  const columns = [
    {
      dataIndex: "date",
      title: "Date",
      render: (date: any, _: any, index: number) => {
        const rowNumber =
          (props?.meta?.current_page - 1) * props?.meta?.take + index + 1;
        return date ? ` ${moment(date).format("DD-MM-YYYY")}` : ` -`;
      },
    },
    {
      dataIndex: "clientId",
      title: "Client ID",
    },
    // {
    //   dataIndex: "date",
    //   title: "Date",
    //   render: (date: any) => (date ? moment(date).format("DD-MM-YYYY") : "-"),
    // },
    {
      dataIndex: "contentIdea",
      title: "Content Idea",
    },
    {
      dataIndex: "channel",
      title: "Channel",
    },
    {
      dataIndex: "contentType",
      title: "Content Type",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() =>
              navigate(`/Admin/Monthlyplanner/planner/Edit/${record?.id}`)
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Card>
        <Table
          columns={columns}
          dataSource={sortedData}
          pagination={false}
          rowKey={(record) => record?.id} // Ensure unique key for each row
        />
        <Pagination
          total={props?.meta?.total_count}
          pageSize={props?.meta?.take}
          current={props?.meta?.current_page}
          onChange={(page, pageSize) => props?.onPageChange(page, pageSize)}
          style={{
            display: props?.meta?.total_count > 10 ? "block" : "none",
            textAlign: "right",
            marginTop: "20px",
          }}
        />
      </Card>
    </div>
  );
}

export default DatatableMonthlyPlanner;
